/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WatcherDto
 */
export interface WatcherDto {
    /**
     * 
     * @type {string}
     * @memberof WatcherDto
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof WatcherDto
     */
    fullName: string;
    /**
     * 
     * @type {Date}
     * @memberof WatcherDto
     */
    grantedAt?: Date | null;
}

/**
 * Check if a given object implements the WatcherDto interface.
 */
export function instanceOfWatcherDto(value: object): value is WatcherDto {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    return true;
}

export function WatcherDtoFromJSON(json: any): WatcherDto {
    return WatcherDtoFromJSONTyped(json, false);
}

export function WatcherDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WatcherDto {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'fullName': json['fullName'],
        'grantedAt': json['grantedAt'] == null ? undefined : (new Date(json['grantedAt'])),
    };
}

export function WatcherDtoToJSON(json: any): WatcherDto {
    return WatcherDtoToJSONTyped(json, false);
}

export function WatcherDtoToJSONTyped(value?: WatcherDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'fullName': value['fullName'],
        'grantedAt': value['grantedAt'] == null ? undefined : ((value['grantedAt'] as any).toISOString()),
    };
}

